// Mock data extracted/derived from newrealmonline.com

export const NAV_LINKS = [
  { name: 'HOME', to: '/' },
  { name: 'ABOUT', to: '/about' },
  { name: 'CRAFTING', to: '/crafting' },
  { name: 'STORE', to: '/store' },
  { name: 'NEWS', to: '/news' },
];

export const ASSETS = {
  // Hero backdrop composition - founder knight scene
  titleArt: '/images/hero_backdrop.jpg',
  envGrass: '/images/slide_meadow.jpg',
  envSnow: '/images/slide_slime.jpg',
  envCave: '/images/secret_deal.jpg',
  envDesert: '/images/founder_scene.jpg',
};

export const CLASSES = [
  {
    name: 'Fire',
    color: '#e8541d',
    img: '/images/class_fire.png',
    description: 'Wield the searing flame to scorch your enemies.',
  },
  {
    name: 'Earth',
    color: '#5a8a3a',
    img: '/images/class_earth.png',
    description: 'Channel the strength of the mountains and forest.',
  },
  {
    name: 'Water',
    color: '#2f7bd3',
    img: '/images/class_water.png',
    description: 'Command tides and frost to wash foes away.',
  },
  {
    name: 'Air',
    color: '#e6e6e6',
    img: '/images/class_air.png',
    description: 'Strike with the speed of wind and storm.',
  },
];

export const COMPANIONS = [
  {
    name: 'Baby Goat',
    type: 'PET',
    img: '/companions/baby_goat.png',
  },
  {
    name: 'Jorin',
    type: 'NPC',
    img: '/companions/jorin.png',
  },
  {
    name: 'The Chieftain',
    type: 'NPC',
    img: '/companions/chieftain.png',
  },
  {
    name: 'Warrior Maiden',
    type: 'FRIEND',
    img: '/companions/warrior_maiden.png',
  },
  {
    name: 'Village Guard',
    type: 'NPC',
    img: '/companions/village_guard.png',
  },
  {
    name: 'Wandering Monk',
    type: 'NPC',
    img: '/companions/wandering_monk.png',
  },
];

export const HOUSES = [
  '/images/class_fire.png',
  '/images/class_earth.png',
  '/images/class_water.png',
  '/images/class_air.png',
];

export const FOLLOW_LINKS = [
  { name: 'Facebook', href: 'https://www.facebook.com/' },
  { name: 'Instagram', href: 'https://www.instagram.com/' },
  { name: 'Twitter', href: 'https://www.twitter.com/' },
  { name: 'YouTube', href: 'https://www.youtube.com/' },
];

export const RECIPE_SETS = [
  {
    id: 'nordic',
    name: 'Nordic Set',
    accent: '#c9b27a',
    preview:
      'https://customer-assets.emergentagent.com/job_monline-revival/artifacts/v7kkoecr_image%20%289%29.png',
    previewLabel: 'Full Set Preview · All Angles',
  },
  {
    id: 'knight',
    name: "Knight's Plate Set",
    accent: '#b8b8b8',
    preview: null,
    previewLabel: null,
  },
  {
    id: 'traveler',
    name: 'Traveler Set',
    accent: '#3e6b8a',
    preview:
      'https://customer-assets.emergentagent.com/job_monline-revival/artifacts/skga94qo_WIP%20S%20N.png',
    previewLabel: 'Concept · WIP',
    previewSize: 'corner',
  },
];

export const RECIPES = [
  {
    id: 'nordic-helmet',
    set: 'nordic',
    name: 'Nordic Helmet',
    slot: 'Head',
    icon: 'HardHat',
    accent: '#c9b27a',
    ingredients: [
      { name: 'Leather', icon: 'Layers', qty: 1 },
      { name: 'Yarn', icon: 'CircleDot', qty: 2, sub: '3x Soft Linen each' },
      { name: 'Steel Sheets', icon: 'Square', qty: 1, sub: '3x Iron Blocks' },
      { name: 'Mountain Water', icon: 'Droplets', qty: 2 },
    ],
  },
  {
    id: 'nordic-tunic',
    set: 'nordic',
    name: 'Nordic Tunic',
    slot: 'Chest',
    icon: 'Shirt',
    accent: '#a8895c',
    ingredients: [
      { name: 'Leather', icon: 'Layers', qty: 2 },
      { name: 'Yarn', icon: 'CircleDot', qty: 2, sub: '3x Soft Linen each' },
      { name: 'Rope', icon: 'Spline', qty: 2, sub: '3x Soft Linen + 1x Yarn each' },
    ],
  },
  {
    id: 'nordic-gloves',
    set: 'nordic',
    name: 'Nordic Gloves',
    slot: 'Hands',
    icon: 'Hand',
    accent: '#b89766',
    ingredients: [
      { name: 'Leather', icon: 'Layers', qty: 2 },
      { name: 'Yarn', icon: 'CircleDot', qty: 2, sub: '3x Soft Linen each' },
      { name: 'Rope', icon: 'Spline', qty: 1, sub: '3x Soft Linen + 1x Yarn' },
      { name: 'Steel Sheets', icon: 'Square', qty: 1, sub: '3x Iron Blocks' },
    ],
  },
  {
    id: 'nordic-pants',
    set: 'nordic',
    name: 'Nordic Pants',
    slot: 'Legs',
    icon: 'PersonStanding',
    accent: '#9a7d50',
    ingredients: [
      { name: 'Leather', icon: 'Layers', qty: 2 },
      { name: 'Rope', icon: 'Spline', qty: 2, sub: '3x Soft Linen + 1x Yarn each' },
      { name: 'Steel Sheets', icon: 'Square', qty: 2, sub: '3x Iron Blocks each' },
    ],
  },

  // Knight's Plate Set
  {
    id: 'knight-helmet',
    set: 'knight',
    name: 'Iron Helmet',
    slot: 'Head',
    icon: 'HardHat',
    accent: '#b8b8b8',
    ingredients: [
      { name: 'Iron Ore', icon: 'Mountain', qty: 1 },
      { name: 'Soft Linen', icon: 'Feather', qty: 2 },
      { name: 'Iron Block', icon: 'Box', qty: 1 },
      { name: 'Iron Nail', icon: 'Pin', qty: 1 },
      { name: 'Firewood', icon: 'Flame', qty: 1 },
    ],
  },
  {
    id: 'knight-plate',
    set: 'knight',
    name: "Knight's Plate",
    slot: 'Chest',
    icon: 'Shield',
    accent: '#cfcfcf',
    ingredients: [
      { name: 'Iron Ore', icon: 'Mountain', qty: 2 },
      { name: 'Iron Block', icon: 'Box', qty: 2 },
      { name: 'Soft Linen', icon: 'Feather', qty: 2 },
    ],
  },
  {
    id: 'knight-gloves',
    set: 'knight',
    name: 'Iron Gloves',
    slot: 'Hands',
    icon: 'Hand',
    accent: '#a8a8a8',
    ingredients: [
      { name: 'Iron Ore', icon: 'Mountain', qty: 2 },
      { name: 'Soft Linen', icon: 'Feather', qty: 1 },
      { name: 'Firewood', icon: 'Flame', qty: 1 },
      { name: 'Iron Block', icon: 'Box', qty: 1 },
    ],
  },
  {
    id: 'knight-legs',
    set: 'knight',
    name: 'Iron Leg Armor',
    slot: 'Legs',
    icon: 'PersonStanding',
    accent: '#9a9a9a',
    ingredients: [
      { name: 'Iron Ore', icon: 'Mountain', qty: 1 },
      { name: 'Firewood', icon: 'Flame', qty: 1 },
      { name: 'Iron Block', icon: 'Box', qty: 2 },
      { name: 'Aluminium Ore', icon: 'Gem', qty: 1 },
    ],
  },

  // Traveler Set
  {
    id: 'traveler-coat',
    set: 'traveler',
    name: 'Traveler Coat',
    slot: 'Chest',
    icon: 'Shirt',
    accent: '#3e6b8a',
    ingredients: [
      { name: 'Cooper Block', icon: 'Box', qty: 1 },
      { name: 'Magic Mineral', icon: 'Gem', qty: 2 },
      { name: 'Aluminium Block', icon: 'Box', qty: 1 },
      { name: 'Yarn', icon: 'CircleDot', qty: 1, sub: '3x Soft Linen' },
      { name: 'Mountain Water', icon: 'Droplets', qty: 1 },
    ],
  },
  {
    id: 'traveler-hat',
    set: 'traveler',
    name: 'Traveler Hat',
    slot: 'Head',
    icon: 'HardHat',
    accent: '#2f5a78',
    ingredients: [
      { name: 'Leather', icon: 'Layers', qty: 2 },
      { name: 'Mountain Water', icon: 'Droplets', qty: 1 },
      { name: 'Magic Mineral', icon: 'Gem', qty: 2 },
      { name: 'Rope', icon: 'Spline', qty: 1, sub: '3x Soft Linen + 1x Yarn' },
    ],
  },
  {
    id: 'traveler-pants',
    set: 'traveler',
    name: 'Traveler Pants',
    slot: 'Legs',
    icon: 'PersonStanding',
    accent: '#3a627d',
    ingredients: [
      { name: 'Iron Block', icon: 'Box', qty: 1 },
      { name: 'Leather', icon: 'Layers', qty: 2 },
      { name: 'Rope', icon: 'Spline', qty: 1, sub: '3x Soft Linen + 1x Yarn' },
      { name: 'Magic Mineral', icon: 'Gem', qty: 2 },
    ],
  },
  {
    id: 'traveler-gloves',
    set: 'traveler',
    name: 'Traveler Gloves',
    slot: 'Hands',
    icon: 'Hand',
    accent: '#456f8f',
    ingredients: [
      { name: 'Iron Block', icon: 'Box', qty: 1 },
      { name: 'Yarn', icon: 'CircleDot', qty: 2, sub: '3x Soft Linen each' },
      { name: 'Leather', icon: 'Layers', qty: 2 },
      { name: 'Magic Mineral', icon: 'Gem', qty: 1 },
    ],
  },
];

export const ENEMIES = [
  { name: 'Salamander', level: 6, img: '/enemies/salamander.png', element: 'Fire' },
  { name: 'Slime', level: 4, img: '/enemies/slime.png', element: 'Water' },
  { name: 'Snail', level: 5, img: '/enemies/snail.png', element: 'Earth' },
  { name: 'Flower', level: 6, img: '/enemies/flower.png', element: 'Earth' },
  { name: 'Yeti', level: 7, img: '/enemies/yeti.png', element: 'Air' },
];

export const BOSS = {
  name: 'Angry Ogre',
  level: 'Boss',
  img: '/enemies/angry_ogre.png',
};

export const NEWS_ITEMS = [
  {
    id: 0,
    featured: true,
    title: 'Dev Diary: Inside Tempest of Shadows — The Vision for New Realm Online',
    date: 'May 20, 2026',
    excerpt:
      'A deep look at the world of Eldoria, our four elemental classes, the Burst combat system, and the choices that will shape your story.',
    body: [
      {
        heading: 'The world: A Kingdom Under Shadow',
        text:
          'New Realm Online is set in the Kingdom of Eldoria — once vibrant, now overshadowed by an unseen darkness. ' +
          'Treacherous seas surround the land and legends speak of storms conjured by dark magic. You wash ashore as a ' +
          'shipwrecked sailor with no memory of how you got there, only to discover a village struggling under the grip of fear, ' +
          'greed, and a sorceress named Lyra whose illusions have turned neighbor against neighbor.',
      },
      {
        heading: 'A story about fear, greed, and redemption',
        text:
          'The opening chapter, “Tempest of Shadows,” follows three intertwined themes. Fear is shown as both a weakness ' +
          'and a catalyst for growth. Greed shows how the pursuit of wealth and power can break a community. And ' +
          'redemption tests whether forgiveness — for others and for ourselves — is possible. Your choices throughout ' +
          'the journey will shape both your reputation and the future of Eldoria, with multiple endings to discover.',
      },
      {
        heading: 'Faces of Eldoria',
        text:
          'You will meet Mira, a fierce warrior who protects what remains of the village and becomes your first true ally; ' +
          'Eldrin, an ancient forest spirit who mentors you on the nature of fear and illusion; villagers like Jorin and ' +
          'the Chieftain Finn whose side-stories reveal the cost of Lyra’s deceptions; and of course Lyra herself — once ' +
          'a guardian of Eldoria, now an antagonist whose redemption arc may surprise you.',
      },
      {
        heading: 'Four elemental classes, one Burst combat system',
        text:
          'Pick one of four elemental classes — Fire (DPS), Earth (Tank/Hybrid), Water (Support/Tank), or Air ' +
          '(Support/DPS) — each with its own basic skill kit such as Fire Slash, Mother Earth, Ice Wall, and Wind Charge. ' +
          'Combat is turn-based and speed-driven: the character with the highest agility moves first. Parties can chain ' +
          'their attacks into a Burst, gaining bonus experience for diverse class compositions, well-timed buffs and ' +
          'debuffs, and successful combos. Pull off the ultimate four-way combo and you can stack over +140% on top of ' +
          'your base experience for that battle.',
      },
      {
        heading: 'Companions, pets, and your own home',
        text:
          'Friendship matters in Eldoria. Build trust with allies to unlock cooperative abilities and combo attacks. ' +
          'Adopt pets like the Baby Goat that follow you in the open world, gain experience alongside you, and evolve as ' +
          'they level up. When you’re ready to settle down, drop a house onto any walkable spot, step inside, and craft ' +
          'workbenches, forges, smithing tables and furniture — even invite friends to visit your home if you want.',
      },
      {
        heading: 'Illusions, choices, and what comes next',
        text:
          'Beyond combat, the world is full of illusion-based puzzles that test your perception and a morality system ' +
          'that tracks how you treat NPCs. Help villagers confront their fears and you gain allies; succumb to greed and ' +
          'you risk isolation. After “Tempest of Shadows,” the post-launch DLC “Shadows of the Veil” will pit you ' +
          'against a secret society rallying support among the villagers who survived Lyra’s reign. The fight against ' +
          'darkness is far from over — and the realm needs heroes like you.',
      },
    ],
  },
  {
    id: 1,
    featured: false,
    title:
      'Discover New Realm Online: A Free Indie MMORPG and Mobile Fantasy RPG for 2026',
    date: 'May 22, 2026',
    excerpt:
      'Looking for a new MMORPG to play in 2026? New Realm Online is a free indie fantasy RPG with turn-based combat, deep crafting, housing, and pets — coming to iOS, Android, and PC. Download the demo APK today and step into the Kingdom of Eldoria.',
    body: [
      {
        heading: 'A new indie MMORPG worth watching in 2026',
        text:
          'New Realm Online is a free-to-play indie MMORPG built for players who miss the slow, social, story-driven feel ' +
          'of the classic fantasy RPGs they grew up with. No pay-to-win shops, no endless gear treadmills — just a hand-crafted ' +
          'open world MMORPG, a turn-based combat system, and a kingdom called Eldoria that genuinely reacts to the ' +
          'choices you make. Whether you are searching for a new mobile MMORPG, the best free indie RPG of 2026, or a ' +
          'cross-platform fantasy game you can play on iOS, Android and PC, New Realm Online is built with you in mind.',
      },
      {
        heading: 'Turn-based RPG combat with a Burst twist',
        text:
          'Combat in New Realm Online is turn-based, fast, and party-driven. Pick one of four elemental classes — Fire, ' +
          'Water, Earth, or Air — and chain attacks with your party to trigger a Burst, our signature combo system. ' +
          'Time your buffs and debuffs perfectly and you can stack over +140% bonus experience in a single battle. ' +
          'If you love tactical RPGs, JRPG-style turn-based combat, and the strategy of an MMORPG raid in a compact ' +
          'fight, this is the indie game you have been waiting for.',
      },
      {
        heading: 'Open world, housing, and deep crafting MMO gameplay',
        text:
          'Crafting MMORPG fans, welcome home. Gather materials across Eldoria, forge legendary armor like the Nordic ' +
          'Set or Knight’s Plate at any anvil, brew potions, and cook food that buffs your party. When you’re ready to ' +
          'settle down, drop a house anywhere walkable in the open world and decorate it with workbenches, forges, and ' +
          'furniture. Invite friends to visit, craft together, and build a guild hall — the housing system is one of the ' +
          'features players asked us for most, and it is fully playable in the demo.',
      },
      {
        heading: 'Pets, companions, and a story RPG that reacts to you',
        text:
          'Adopt a Baby Goat, a wandering monk, a Warrior Maiden or one of the many other companions and pets scattered ' +
          'across the realm. Pets follow you into the open world, gain experience alongside you, and evolve as they level ' +
          'up. The story RPG layer of New Realm Online tracks a morality system that quietly remembers how you treat NPCs ' +
          '— help villagers confront their fears and you gain allies; succumb to greed and you risk isolation. Multiple ' +
          'endings, branching side stories, and a post-launch DLC called Shadows of the Veil mean your save is never ' +
          'really finished.',
      },
      {
        heading: 'Cross-platform: mobile MMORPG on iOS, Android, and PC',
        text:
          'New Realm Online is designed mobile-first but plays beautifully on desktop. Touch controls, gamepad support, ' +
          'and a clean UI that scales from phone to ultrawide monitor. If you are looking for the best free MMORPG for ' +
          'Android in 2026, an iOS RPG with controller support, or a lightweight PC MMO you can play on a laptop, the ' +
          'realm is open to you. Cloud saves keep your character in sync across every device you own.',
      },
      {
        heading: 'How to play the demo today',
        text:
          'You don’t have to wait for launch — the New Realm Online demo is live right now. Download the APK directly ' +
          'from our home page, install it on Android, and explore the prologue of Tempest of Shadows for free. iOS ' +
          'TestFlight and a Windows PC build are landing in upcoming patches. Buy Sapphires from the Store to support ' +
          'development, or drop a tip on the Donate page if you just want to keep the lights on — every contribution ' +
          'goes back into the game. Welcome to Eldoria. The realm has been waiting for you.',
      },
    ],
    keywords: [
      'indie MMORPG',
      'free MMORPG 2026',
      'mobile MMORPG',
      'turn-based RPG',
      'fantasy RPG',
      'open world RPG',
      'crafting MMORPG',
      'Android RPG APK',
      'iOS RPG',
      'best indie RPG 2026',
      'free to play MMO',
      'New Realm Online',
      'Eldoria',
    ],
  },
];
